import { render } from "./EditAttribute.vue?vue&type=template&id=5ff0f2c0&ts=true"
import script from "./EditAttribute.vue?vue&type=script&lang=ts"
export * from "./EditAttribute.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__